module.exports = __webpack_public_path__ + "img/path-1.e4b1549d.png";